import { nextTick as c, h as r } from "vue";
import l from "./insert-css.js";
function f(n, i) {
  process.env.NODE_ENV !== "production" && !n && console !== void 0 && console.error(`Warning: ${i}`);
}
function g(n, i) {
  f(n, `[@pf-ui/pf-icons-vue] ${i}`);
}
function u(n) {
  return typeof n == "object" && typeof n.name == "string" && typeof n.theme == "string" && (typeof n.icon == "object" || typeof n.icon == "function");
}
function a(n, i, o) {
  return o ? r(
    n.tag,
    {
      key: i,
      ...o,
      ...n.attrs
    },
    (n.children || []).map((e, t) => a(e, `${i}-${n.tag}-${t}`))
  ) : r(
    n.tag,
    { key: i, ...n.attrs },
    (n.children || []).map((e, t) => a(e, `${i}-${n.tag}-${t}`))
  );
}
function y(n) {
  return n ? Array.isArray(n) ? n : [n] : [];
}
const b = {
  width: "1em",
  height: "1em",
  fill: "currentColor",
  "aria-hidden": "true",
  focusable: "false"
}, m = `
.anticon {
  display: inline-block;
  color: inherit;
  font-size: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
let s = !1;
const h = (n = m) => {
  c(() => {
    s || (typeof window < "u" && window.document && window.document.documentElement && l(n, {
      prepend: !0
    }), s = !0);
  });
};
export {
  a as generate,
  m as iconStyles,
  u as isIconDefinition,
  y as normalizeTwoToneColors,
  b as svgBaseProps,
  h as useInsertStyles,
  f as warn,
  g as warning
};
